import clsx from 'clsx';

const columns = {
  2: 'md:grid-cols-2',
  3: 'md:grid-cols-3',
  4: 'md:grid-cols-4',
  5: 'md:grid-cols-5',
  6: 'md:grid-cols-6',
};

export default function StatHeader({ stats }) {
  return (
    <dl
      className={clsx(
        'mb-5 grid grid-cols-1 divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow md:divide-x md:divide-y-0',
        columns[stats.length],
      )}
    >
      {stats.map((stat) => (
        <div
          key={stat.name}
          className={clsx('px-4 py-5 sm:p-6', stat.onClick && 'cursor-pointer')}
          onClick={stat.onClick}
        >
          <dt className="text-base font-normal text-gray-900">{stat.name}</dt>
          <dd className="mt-1 flex flex-col items-baseline justify-between md:block lg:flex">
            <div className="text-2xl font-semibold text-gray-900 w-full">{stat.value}</div>
            <div className="mt-2">{stat.secondaryValue}</div>
          </dd>
        </div>
      ))}
    </dl>
  );
}
